import React, { FC } from 'react'
import { PointWithElement } from './PointWithElement'
import { Wrapper, Contact, Title, Instructions, Info, Href } from './styled'

export const ContactsComponent: FC = () => (
	<Wrapper>
		<Contact>
			<Title>Техническая поддержка 24/7</Title>
			<PointWithElement text=" доб. 913 — для звонков с мобильных" textColor="0321" />
			<PointWithElement text=" доб. 913 — для звонков внутри РФ" textColor="+7 800 555 57 77" />
			<PointWithElement text=" доб. 913 — для звонков из-за границы" textColor="+7 495 665 57 77" />
		</Contact>
		<Instructions>
			<Info>Инструкции по работе с эквайрингом</Info>
			<Href href="http://www.sberbank.ru/ru/s_m_business/help/aquiring">
				Перейти в справочный центр
			</Href>
		</Instructions>
	</Wrapper>
)
